import "./App.css";
import MainContainer from "./MainContainer";
import { AuthProvider } from "./Context/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MainContainer />
      </AuthProvider>
    </div>
  );
}

export default App;
